import { Directive, Input, OnInit, Signal, computed } from '@angular/core';
import { FeatureConfigDirective } from './feature-config.directive';

/**
 * @description
 * Read textual content of a specific text variable which is part of a feature's configuration > text collection.
 */

@Directive({
  selector: '[textConfig]',
  standalone: true,
  exportAs: 'text'
})
export class TextConfigDirective extends FeatureConfigDirective implements OnInit {
  @Input()
  textConfig: string;

  value$$: Signal<string>;

  ngOnInit(): void {
    /** translate the variable name to its value */
    this.value$$ = computed(() => {
      const value = this.fromText$$(this.textConfig);
      return value();
    });
  }
}
